import { render } from "./Instructions.vue?vue&type=template&id=ba9a962e&ts=true"
import script from "./Instructions.vue?vue&type=script&lang=ts"
export * from "./Instructions.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__